import { render, staticRenderFns } from "./OnTImeOff.vue?vue&type=template&id=63573fb7&scoped=true&"
import script from "./OnTImeOff.vue?vue&type=script&lang=js&"
export * from "./OnTImeOff.vue?vue&type=script&lang=js&"
import style0 from "./OnTImeOff.vue?vue&type=style&index=0&id=63573fb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63573fb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VSpacer})
